/**
 * Created by vladislav on 2/20/2024
 */

connector.EXCHANGE_RATES = {
    USD: 1,
    EUR: 0.87,
    RUB: 80,
    GBP: 0.74,
    DEM: 1.7,
    JPY: 157,
    INR: 95,
    FRF: 5.7,
    CAD: 1.4,
    AUD: 1.43,
    BEF: 35.1,
    CNY: 6.77,
    SGD: 1.28,
    PLN: 3.74,

    KRW: 1430,
    COP: 3155,
    HUF: 316,
    ARS: 1493,
    KZT: 474,
    IQD: 1312,
    ISK: 123,
    TRY: 47.55,
    CLP: 930,
    NOK: 9.54,
    UAH: 45,
    DKK: 6.48,
    MYR: 4.09,
    THB: 33.4,
    ZAR: 16.52,
    EGP: 50.26,
    BRL: 5.07,
    NZD: 1.7,
    SEK: 9.55,
    TWD: 32.34,
    SAR: 3.75,
    HKD: 7.84,
    CZK: 21.01,
    MXN: 17.32,
    CHF: 0.81,
    JOD: 0.71,
    ILS: 3.05,
    RON: 4.55,
    OMR: 0.38,

    mygames: {
        RUB: 30
    },

    wechat: {
        CNY: 5
    },

    yookassa: {
        RUB: 50
    },

    robokassa: {
        RUB: 50
    },

    rustore: {
        RUB: 50
    }
};

connector.VIRTUAL_EXCHANGE_RATES = {
    FM: 1,
    MC: 100,
    KG: 10,
    MLK: 30,
    OK: 30,
    VK_GOLOS: 4.275,
    WECHAT_GEMS: 10,
    YAN: 30,
    XTR: 43,
    ARKADIUM_GEMS: 30,
    BEANS: 100,
    RDT: 25
};

// What one unit of each virtual currency is actually worth, in the currency that platform
// really charges in. Combined with VIRTUAL_EXCHANGE_RATES it yields the coefficient that
// converts a virtual-currency purchase back into real USD for revenue reporting - see
// PaymentsManager.getVirtualCurrencyUSDCoef. Kept here so a pricing change and its reporting
// coefficient cannot drift apart.
// "rub" entries follow EXCHANGE_RATES.RUB; "usd" entries are independent of it, which matters
// for the platforms that never dealt in rubles.
// Currencies absent from this table are reported at their full nominal USD price.
connector.VIRTUAL_CURRENCY_UNIT_VALUE = {
    FM: { rub: 30 },
    OK: { rub: 1 },
    VK_GOLOS: { rub: 7 },
    MLK: { rub: 1 },
    YAN: { rub: 1 },
    ARKADIUM_GEMS: { usd: 0.025 },
    RDT: { usd: 0.02 }
};